/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AutomationTemplateQueryScope extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AutomationTemplateQueryScope");
    }

    getFixupPrototypeFunction() { return AutomationTemplateQueryScope.fixupPrototype; }

    static newInstance(model: Partial<AutomationTemplateQueryScope>): AutomationTemplateQueryScope {
        let obj = Object.assign(new AutomationTemplateQueryScope(), model);
        AutomationTemplateQueryScope.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AutomationTemplateQueryScope>): AutomationTemplateQueryScope {
        if (!model) return null;
        return AutomationTemplateQueryScope.newInstance(<AutomationTemplateQueryScope> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AutomationTemplateQueryScope) {
        if (!obj) return;

        models.AutomationTemplateQueryScope.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AutomationTemplateQueryScope): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AutomationTemplateQueryScope.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Template account scopes to include
     */
    scopes: Array<models.AccountScope>;

}
